import { Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useGetOneContent } from "src/api/client-api/cms/useGetOneContent";
import { MainContentLayout } from "src/components/Layout/MainContentLayout";
import { Loading } from "src/components/utils/Loading";
import { useFoodpilotContext } from "src/context/FoodpilotContext";
import { HomeCMS_ID } from "../../api/client-api/cms/useCreateHomePage";
import { SectionSelector } from "src/components/CMS/Widgets/SectionSelector";
import { useSectionsConfig } from "src/api/client-api/cms/sections/sectionsConfig";
import { PuckRenderer } from "src/components/Puck/PuckRenderer";
import { useApplicationParameters } from "src/api/client-api/appParams";
import { useGetPuckPage } from "src/api/client-api/cms/useGetPuckPage";

export const Homepage = () => {
    const { t } = useTranslation();
    const theme = useTheme();
    const { user } = useFoodpilotContext();
    const { content, isFetched } = useGetOneContent({ contentId: HomeCMS_ID });
    const { page, isFetched: isPuckPageFetched } = useGetPuckPage({ slug: HomeCMS_ID });
    const sectionConfig = useSectionsConfig();
    const { applicationParameters } = useApplicationParameters();

    const puckPage = JSON.parse(page?.content || "{}");
    if (isFetched === false || isPuckPageFetched === false) {
        return <Loading />;
    }

    if (content === undefined) {
        return null;
    }

    const name = user.trustedUser.firstname;

    return (
        <>
            {applicationParameters?.["FS-homepage"] === "true" && (
                <MainContentLayout>
                    <Stack width={"100%"}>
                        <Typography variant={"h1"} margin={theme.spacing(0, 0, 4.5, 0)}>
                            {`${t("glossary.hello")} ${name} !`}
                        </Typography>
                        {content.sections.map((section, index) => {
                            const config = sectionConfig[section.type];
                            if (config.isDisabled === true) return null;
                            if (section.visible === false) return null;
                            return (
                                <Stack key={section.id}>
                                    <SectionSelector section={section} index={index} />
                                </Stack>
                            );
                        })}
                    </Stack>
                </MainContentLayout>
            )}
            {applicationParameters?.["FS-puck-homepage"] === "true" && <PuckRenderer data={puckPage} />}
        </>
    );
};
